"use client";
const S = [
  "API",
  "AWS",
  "GCP",
  "SQL",
  "CSS",
  "JS",
  "JDK",
  "SDK",
  "JRE",
  "IDE",
  "XML",
  "GUI",
  "CLI",
  "AI",
  "ML",
  "DL",
  "IoT",
  "TCP",
  "UDP",
  "IP",
  "FTP",
  "RAM",
  "ROM",
  "SSD",
  "HDD",
  "VPS",
  "VPN",
  "OS",
  "UI",
  "UX",
  "DB",
  "OOP",
  "CRM",
  "ERP",
  "POS",
  "CAD",
  "BI",
  "CMS",
  "SEO",
  "SEM",
  "PPC",
  "B2B",
  "B2C",
  "SMB",
  "ROI",
  "KPI",
  "CTA",
  "CPC",
  "CPM",
  "CDN",
  "MVC",
  "FAQ",
  "LMS",
  "RPA",
  "QA",
  "QC",
  "CRO",
  "SVN",
  "GIT",
  "DOM",
  "DNS",
  "ISP",
  "URL",
  "URN",
  "URI",
  "SIP",
  "NFC",
  "LTE",
  "OSI",
  "RAS",
  "DRM",
  "DOS",
  "WWW",
  "LAN",
  "WAN",
  "SAN",
  "NAS",
  "NLP",
  "OCR",
  "IBM",
  "HP",
  "SAP",
  "JWT",
  "SSH",
  "SSL",
  "TLS",
  "POP",
  "NTP",
  "BGP",
  "ARP",
  "2FA",
  "MFA",
  "RDP",
  "VNC",
  "SCP",
  "PKI",
  "XSS",
  "DoS",
  "CSV",
  "HL7",
  "SOP",
  "PHP",
  "JSP",
  "NET",
  "VBA",
  "iOS",
  "GNU",
  "CPU",
  "GPU",
  "NIC",
  "USB",
  "VGA",
  "AES",
  "RSA",
  "DES",
  "ECC",
  "WEP",
  "WPA",
  "IDS",
  "IPS",
  "PM",
  "HR",
  "TCO",
  "BPM",
  "SLA",
  "SOW",
  "AR",
  "VR",
  "XR",
  "3D",
  "2D",
  "4D",
  "iOS",
  "OpenAPI",
  "SSO"
];
export {
  S as short
};
